export default __webpack_public_path__ + "static/media/220.eb8d4c30.jpg";